import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false,
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__ivr-ivr',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__ivr-ivr .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__section--ivr-get-payments',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__section--ivr-get-payments .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__section--ivr-works',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__section--ivr-works .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__columns--ivr-second',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__columns--ivr-second .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);

});



// WEBPACK FOOTER //
// ./app/scripts/pages/solutions/ivr-interface.js